import styles from './Accounting.module.css'
import sidebarStyles from "../bets/sidebar/Sidebar.module.css"
import { AccountingIF } from '../reports/types'
import { useEffect, useState } from 'react'
import { AccountingOverview } from './AccountingOverview'
import { AccountingPeriod, AccountingTimePeriodsType, setPeriodRange } from './helpers'
import { UTCToEST } from '../../utils/timezone'
import { Dropdown } from '../../components/Dropdown'
import { getAccountingReport } from '../../services/api'
import { AccountingCard } from './AccoutingCard'
import Loader from 'react-spinners/BounceLoader'
import { getDisplayEndDate } from '../reports/helpers'


export const Accounting = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [report, setReport] = useState<AccountingIF>()
    const [period, setPeriod] = useState<AccountingPeriod>(
        setPeriodRange(
            AccountingTimePeriodsType.WEEK
        )
    )

    useEffect(() => {
        const abortController = new AbortController();
        (async () => {
            setIsLoading(true);
            const res = await getAccountingReport(period.start, period.end)
            if (!abortController.signal.aborted) {
                if (!res?.userTotals || res.userTotals.length === 0 || !res.totals) {
                    setIsLoading(false)
                    return
                }
            }
            res && setReport(
                {
                    totals: res.totals,
                    userTotals: res.userTotals
                }
            )
            setIsLoading(false)
        })()
        return () => abortController.abort()

    }, [period])

    return (
        <div className={styles.content}>
            <div className={sidebarStyles.sidebar}>
                <header>Overview</header>
                <AccountingOverview overview={report?.totals} isLoading={isLoading} />
            </div>
            <div className={styles.accounting}>
                <div className={styles.header}>
                    <header>
                        {`From ${UTCToEST(period.start)} to ${UTCToEST(getDisplayEndDate(period.end))} (${period.type})`}
                    </header>
                    <div className={styles.period_selector}>
                        <Dropdown
                            options={Object.values(AccountingTimePeriodsType)}
                            onSelect={(option) => option && setPeriod(
                                setPeriodRange(option as AccountingTimePeriodsType)
                            )}
                            value={period.type}
                            defaultValue={AccountingTimePeriodsType.WEEK}
                        />
                    </div>
                </div>
                <div className={styles.container}>
                    {!isLoading && report && report.userTotals ? <>
                        {Object.values(report!.userTotals).map((user) =>
                            <div style={{ padding: "4px" }}>
                                <AccountingCard user={user} />
                            </div>
                        )}
                    </> : <div className={styles.loading}>
                        <Loader
                            loading={isLoading}
                            size={24}
                            color={'var(--dark2)'}
                        />
                    </div>}
                </div>
            </div>
        </div>
    )
}
